export default __webpack_public_path__ + "static/media/money.83274c2a.svg";